import React from "react";
import { Menu } from "antd";
import classnames from "classnames";

import WeaNewScroll from "../wea-new-scroll";
import Extents from "../wea-rich-text/Extents";

const getRouteList = ({ path, childRoutes }) => {
  let list = path ? [path] : [];
  if (
    childRoutes &&
    Object.prototype.toString.call(childRoutes) === "[object Array]"
  ) {
    childRoutes.forEach(c => {
      list = list.concat(
        getRouteList(c).map(l =>
          /^\//.test(l) ? l : `${path === "/" ? "" : path}/${l}`
        )
      );
    });
  }
  return list;
};

export default class WeaDebugRouteMenu extends React.Component {
  static displayName = "WeaDebugRouteMenu";
  static defaultProps = {
    showRouteLev: 3,
    className: "",
    style: {}
  };
  constructor(props) {
    super(props);
    this.preCls = "wea-debug-route-menu";
    this.state = {
      show: false
    };
  }
  componentDidMount() {
    const {
      location: { pathname }
    } = this.props;
    if (pathname === "/" || pathname.split("/").length === 2)
      this.setState({ show: true });
  }
  getList() {
    const { route, showRouteLev } = this.props;
    const list = getRouteList(route);
    return list.filter(l => l.split("/").length < showRouteLev + 2);
  }
  render() {
    const { show } = this.state;
    const { children, route, router } = this.props;
    if (!route) return <div>请检查是否配置了路由</div>;
    const menu = (
      <Menu
        onClick={({ key }) => {
          router.push(key);
          this.setState({ show: false });
        }}
      >
        {this.getList().map(l => (
          <Menu.Item key={l}>{l}</Menu.Item>
        ))}
      </Menu>
    );

    const wrapCls = classnames({
      [this.preCls]: true,
      [`${this.preCls}-show`]: show
    });
    const btnCls = classnames({
      [`${this.preCls}-btn`]: true,
      [`${this.preCls}-btn-show`]: !show
    });
    return [
      <Extents className={this.preCls} container={document.body}>
        <div className={wrapCls}>
          <WeaNewScroll height="100%">{menu}</WeaNewScroll>
          <div
            className={btnCls}
            title={show ? "隐藏路由" : "显示路由"}
            onClick={() => this.setState({ show: !show })}
          />
        </div>
      </Extents>,
      children
    ];
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-debug-route-menu/index.js